<template>
  <div class="coupon-wrapper clearfix">
    <div class="coupon-list flex-hl-vc flex-hw">
      <template
        v-for="coupon in conditionCoupons"
      >
        <CouponTicket
          :key="coupon.couponCode"
          :data="coupon"
          :checked-able="checkedAble"
          @change="onCouponChange"
        ></CouponTicket>
      </template>
    </div>
    <div class="more-coupon" v-if="coupons?.length > 4" @click="updateConditionCoupons">{{ showMore ? '收起卡券>' : '更多卡券>' }}</div>
    <!-- <a-modal
      title="卡券"
      :visible="showMore"
      @ok="onOk"
      @cancel="onCancel"
      :width="1300"
    >
      <div class="coupon-modal-wrapper flex-hl-vl flex-hw">
        <template
          v-for="(coupon) in coupons"
        >
          <CouponTicket
            :key="coupon.couponCode"
            :data="coupon"
            :checked-able="checkedAble"
            @change="onCouponChange"
          ></CouponTicket>
        </template>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
import CouponTicket from './card-item.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'CouponGroup',
  data () {
    return {
      showMore: false,
      checkedCoupons: [],
      display: 4
    }
  },
  props: {
    coupons: Array,
    checkedAble: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    conditionCoupons () {
      const { coupons, showMore } = this
      const couponsClone = cloneDeep(coupons)

      return !showMore ? couponsClone.splice(0, 4) : couponsClone
    }
  },
  methods: {
    onCouponChange (coupon) {
      this.$emit('change', coupon)
    },
    updateConditionCoupons () {
      this.showMore = !this.showMore
    }
    // changeGroup () {
    //   const checkedCoupons = _.filter(this.coupons, (cpn) => {
    //     return cpn.checked
    //   })

    //   this.checkedCoupons = checkedCoupons || []

    //   this.$emit('change', checkedCoupons)
    // }
    // onOk () {
    //   this.showMore = false

    //   this.changeGroup()
    // },
    // onCancel () {
    //   // 弹窗内取消时，还原原来选中的值
    //   if (this.checkedCoupons.length) {
    //     this.checkedCoupons.forEach((checkCpn) => {
    //       this.coupons.forEach((cpn) => {
    //         cpn.checked = (cpn.key === checkCpn.key)
    //       })
    //     })
    //   }

    //   this.showMore = false
    // }
  },
  components: {
    CouponTicket
  }
}
</script>

<style lang="less" scoped>
  .coupon-wrapper {
    padding-top: 20px;
    .coupon-ticket {
      display: inline-block;
      margin: 10px 0;
      margin-right: 6px;

      &:last-of-type {
        margin-right: 0;
      }
    }

    .more-coupon {
      float: right;
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
      padding-top: 10px;
    }
  }

  .coupon-modal-wrapper {
    width: 100%;
    height: 338px;
    overflow: auto;

    .coupon-ticket {
      display: inline-block;
      margin: 10px 28px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .coupon-wrapper {
      text-align: center;
    }
  }
</style>
